import React from "react";
import FirstBarber from "./components/barbers/FirstBarber";
import SecondBarber from "./components/barbers/SecondBarber";
import ThirdBarber from "./components/barbers/ThirdBarber";
import FourthBarber from "./components/barbers/FourBarber";
import FifthBaber from "./components/barbers/FifthBarber";

const Barber = () => {
  return (
    <>
      <FirstBarber />
      <SecondBarber />
      <ThirdBarber />
      <FourthBarber />
      <FifthBaber />
    </>
  );
};

export default Barber;
